
import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import { TopChannel } from '@/features/dashboard/types';
import ProgressItem from '@/features/dashboard/components/widgets/topChannels/ProgressItem.vue';

@Component({
  components: {
    ProgressItem,
  },
})
export default class Content extends Vue {
  @Prop({ required: true }) periodItems!: Array<string>;

  @PropSync('period', { required: true }) syncedPeriod!: string;

  private colors: Array<string> = ['#2bc5cb', '#cb0f51', '#ffa43c', '#623ec7'];

  get topChannels(): Array<TopChannel> {
    return this.$store.getters.getTopChannels;
  }
}
